export const mergeAndSliceArrays = <TArrayA, TArrayB>(
  strictData: TArrayA[] | undefined,
  relaxedData: TArrayB[] | undefined,
  limit: number
) => [...(strictData ?? []), ...(relaxedData ?? [])].slice(0, limit);
